<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button v-if="$hasPermission('airport.add')" class="float-right" @click="newModel" >Nuevo Aeropuerto</b-button>
					<h2>Aeropuertos</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'places-index-list') } ">
						<div class="row">
								<b-form-group class="col-2" label="Nombre">
									<b-form-input v-model="filters.search" type="text" />
								</b-form-group>
                                <b-form-group class="col-2" label="Ciudad">
									<b-form-input v-model="filters.ciudad" type="text" />
								</b-form-group>
								<b-form-group class="col-2" label=".">
									<b-button type="submit" variant="primary">Buscar</b-button>
								</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						permission-show="airport.show"
						id="places-index-list"
						:filters="filters"
						:columns="modelColumns"
						resource="places"
					>
						<template #cell(actions)="row">
							<div class="text-center">
								<b-button @click="(event) => editModel(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button v-if="$hasPermission('airport.delete')" @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
						<template #cell(locationUrl)="row">
							<div v-if="row.item.locationUrl" class="text-center">
								<a :href="row.item.locationUrl" target="_blank" class="btn btn-sm" variant="info">
									<md-icon icon="place" />
								</a>
							</div>
						</template>
					</AjaxTable>
				</div>
				<hr>
			</div>
			<Single :unableEdit.sync="unableEdit" mode="airport" ref="single" :success-callback="successCallback" />
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'

export default {
		components: { MainLayout, Single, AjaxTable },
		data(){
				return {
					unableEdit: false,
					modalInfo : {
						modelId:-1,
						title:"Aeropuertos",
					},
					filters : {
						search:'',
                        airports: true,
                        ciudad: '',
					},
					modelColumns : [
						{key:'id',label:'ID'},
						{key:'name',label:'Nombre'},
						{key:'destinationName',label:'Ciudad'},
						{key:'countryName',label:'País'},
                        {key:'iata',label:'IATA'},
                        {key:'icao',label:'ICAO'},
                        {key:'referenceToPlace.name',label:'Destino'},
						{key:'locationUrl',label:'Ubicación'},
						{key:'source',label:'Origen'},
						{key:'actions',label:'Acciones'},
					],
				}
		},
		methods:{
			editModel(id) {
				this.unableEdit = !this.$hasPermission('airport.edit')
				this.$refs['single'].loadModel(id)
			},
			successCallback(){
				this.$root.$emit('bv::refresh::table', 'places-index-list')
			},
			newModel(){
				this.unableEdit = false
				this.$refs['single'].loadModel(-1)
			},
			modelDelete(item){
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/places/${item.id}`).then(() => {
							this.$root.showAlert('Registro Eliminado!',{variant:'warning'})
							this.$root.$emit('bv::refresh::table', 'places-index-list')
							this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['airportsOpts'],forceRefresh: true})
							close()
						}).catch( err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
